import { useShallow } from "zustand/react/shallow";
import { useRunControlStore } from "./store";
import { controller } from "./service/controller";

export function useRunControl() {
  const state = useRunControlStore(
    useShallow((store) => ({
      runId: store.runId,
      flowId: store.flowId,
      status: store.status,
      mode: store.mode,
      isBusy: store.isBusy,
      error: store.error,
      connected: store.connected,
      snapshot: store.snapshot,
      queueLen: store.queueLen,
      stackLen: store.stackLen,
      suspendedLen: store.suspendedLen,
      activeNodeIds: store.activeNodeIds,
      breakpoints: store.breakpoints,
      runningNodeIds: store.runningNodeIds,
      waitingNodeIds: store.waitingNodeIds,
      suspendedNodeIds: store.suspendedNodeIds,
      completedNodeIds: store.completedNodeIds,
      failedNodeIds: store.failedNodeIds,
      nodeAttemptCounts: store.nodeAttemptCounts,
      nodeSuccessCounts: store.nodeSuccessCounts,
      nodeFailureCounts: store.nodeFailureCounts,
      pauseReason: store.pauseReason,
      currentSuspendedNodeId: store.currentSuspendedNodeId,
      nodeErrors: store.nodeErrors,
      lastNodeError: store.lastNodeError,
      clearNodeError: store.clearNodeError,
      clearAllErrors: store.clearAllErrors,
      nodeOutputs: store.nodeOutputs,
      lastNodeOutput: store.lastNodeOutput,
      clearNodeOutputs: store.clearNodeOutputs,
      clearAllOutputs: store.clearAllOutputs,
    }))
  );

  return {
    ...state,
    start: controller.start,
    startInteractive: controller.startInteractive,
    pause: controller.pause,
    resume: controller.resume,
    stop: controller.stop,
    refreshStatus: controller.refreshStatus,
    getSnapshot: controller.getSnapshot,
    clear: controller.reset,
    reset: controller.reset,
    step: controller.step,
    continueRun: controller.continueRun,
    addBreakpoints: controller.addBreakpoints,
    removeBreakpoint: controller.removeBreakpoint,
    toggleBreakpoint: controller.toggleBreakpoint,
    deliver: controller.deliver,
    waitForTerminal: controller.waitForTerminal,
  };
}
